import classnames from "classnames";
import * as React from "react";

import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";

type ClassNames = "input";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
  input: {
    display: "flex",
    marginTop: theme.spacing.unit * 2,
    padding: theme.spacing.unit,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.grey[300],
    borderRadius: 5,
  }
});

interface ITextInputProps extends WithStyles<typeof styles>  {
  placeholder: string;
  onChange: (value: string) => void;
  multiline?: boolean;
  rows?: number;
  className?: string;
  defaultValue?: string;
  type?: string;
  value?: string | undefined;
}

class TextInput extends React.PureComponent<ITextInputProps> {

  public static defaultProps = {
    multiline: false,
    rows: 1,
    className: "",
    defaultValue: undefined,
    type: "text",
    value: undefined
  };

  public onChange = (e: React.ChangeEvent<HTMLInputElement>) => 
    this.props.onChange(e.target.value);

  public render() {
    const {
      classes, placeholder, multiline, rows, className, defaultValue, type, value
    } = this.props;
    return (
        <TextField
          className={classnames(className, classes.input)}
          InputProps={{
            type,
            disableUnderline: true,
          }}
          onChange={this.onChange}
          {...{placeholder, multiline, rows, defaultValue, value}}
        />
    );
  }
}

export default withStyles(styles)(TextInput);


// WEBPACK FOOTER //
// ./src/components/TextInput.tsx